export default {
    getHeaderFieldsEprofileAutonomia: state => state.headerFieldsEprofileAutonomia,
    getFormActionsEprofileAutonomia: state => state.formActionsEprofileAutonomia,
    getActionsEprofileAutonomia: state => state.actionsEprofileAutonomia,
    getRowActionsEprofileAutonomia: state => state.rowActionsEprofileAutonomia,
    getSearchFields: state => state.searchFields,
    isFormOpenEprofileAutonomia: state => state.formIsOpen,
    isGridOpenEprofileAutonomia: state => state.gridIsOpen
}
